
import React from 'react';
import BusRatesTable from './BusRatesTable';
import { Helmet } from 'react-helmet';

const Packages = () => {
  return (
   <div>
    <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mumbai Cabs | Affordable & Reliable</title>
  <meta name="description" content="Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699." />
  <meta name="keywords" content="Pune to Mumbai Cab Service, Affordable Cabs Pune to Mumbai, AB Ghule Cabs, Luxury Cabs Pune to Mumbai, Pune to Mumbai cheapest cab, Pune Mumbai Taxi Service, Pune to Mumbai Airport Cabs, Pune to Mumbai Outstation Cabs, Pune to Mumbai Cab Booking Online, Pune Mumbai Express Taxi, Pune to Mumbai Private Cabs, Pune Mumbai One-Way Taxi, Pune to Mumbai Round Trip Cabs, Pune to Mumbai Airport cab, Pune Mumbai Cab, Pune to Mumbai Taxi, Pune to Mumbai Airport Cab Fare, Pune Mumbai Airport Drop, Pune to mumbai cheapest cab, Pune to Mumbai Cab Service, best cab service Pune to Mumbai, Pune to mumbai cab fare, Pune Mumbai taxi service, Pune to Mumbai car, Pune Mumbai taxi fare, Pune to Mumbai international airport cab, Pune to Mumbai cab price, Pune to Mumbai airport cab price, Pune to Mumbai taxi one way, Pune to Mumbai cab booking, Pune to Mumbai airport taxi, Pune Mumbai cab one way" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mumbai Cabs | Affordable & Reliable" />
  <meta property="og:description" content="Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-mumbai-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />
  
  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Mumbai Cabs",
        description: "Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-mumbai-cabs",
        "logo": "https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg",
        "image": "https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg",
        "priceRange": "₹1500 - ₹5000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-mumbai-cabs",
          "priceCurrency": "INR",
          "price": "1500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "1500"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Sneha Kulkarni"
            },
            "datePublished": "2024-12-22",
            "reviewBody": "Seamless booking process and the ride was very comfortable. Highly recommend AB Ghule Cabs for Pune to Mumbai trips."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Vishal Sharma"
            },
            "datePublished": "2024-12-18",
            "reviewBody": "Great service at an affordable price. The driver was professional and punctual."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune and Mumbai",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-mumbai-cabs"
        },
        "keywords": "Pune to Mumbai Cab Service, Affordable Cabs Pune to Mumbai, AB Ghule Cabs, Luxury Cabs Pune to Mumbai, Pune to Mumbai cheapest cab, Pune Mumbai Taxi Service, Pune to Mumbai Airport Cabs, Pune to Mumbai Outstation Cabs, Pune to Mumbai Cab Booking Online, Pune Mumbai Express Taxi, Pune to Mumbai Private Cabs, Pune Mumbai One-Way Taxi, Pune to Mumbai Round Trip Cabs, Pune to Mumbai Airport cab, Pune Mumbai Cab, Pune to Mumbai Taxi, Pune to Mumbai Airport Cab Fare, Pune Mumbai Airport Drop, Pune to mumbai cheapest cab, Pune to Mumbai Cab Service, best cab service Pune to Mumbai, Pune to mumbai cab fare, Pune Mumbai taxi service, Pune to Mumbai car, Pune Mumbai taxi fare, Pune to Mumbai international airport cab, Pune to Mumbai cab price, Pune to Mumbai airport cab price, Pune to Mumbai taxi one way, Pune to Mumbai cab booking, Pune to Mumbai airport taxi, Pune Mumbai cab one way"
      }
    `}
  </script>
</Helmet>

<section id="about" className="jarallax text-light">
    <div className="center-y relative text-center">
        <div className="container">
            <div className="row">
                <div className="col-md-12 text-center">
                    <h1 className='text-white'>Packages</h1>
                </div>
                <div className="clearfix"></div>
            </div>
        </div>
    </div>
</section>
<BusRatesTable/>

<div className="rules-guidelines container">
  <h2>Rules and Guidelines:</h2>
  <ul className="rules-list">
  <li>  Driver Allowance will charge extra.</li>
  <li>  Cab running km is limited to 300 km per day.</li>
  <li>  Time starts from 6:00 AM to 10:00 PM, and the cab must be free at 10:00 PM. After 10:00 PM, extra charges apply. Night charges apply from 12:00 AM to 6:00 AM.</li>
  <li>  Time and km will be calculated from our office to office.</li>
  <li>  Interstate taxes, toll taxes, parking, and service tax are charged as actuals.</li>
  <li>  Extra charges will apply for extra km and hours. Government taxes will be charged as per government rules.</li>
  <li>  The charges quoted above are calculated based on the current fuel prices. Any hike in fuel prices will result in a variation in rates.</li>
</ul>
  {/* <h2>नियम व अटी</h2> */}
  {/* <ul className="rules-list">
    <li> संपूर्ण टोल, पार्किंग, प्रवासी कर, जी.एस.टी. आणि स्पेशल परमिटचा खर्च पार्टीने द्यावयाचा आहे.</li>
    <li> इतर राज्यांचे कर (महाराष्ट्राबाहेरील) पार्टीने भरावयाचा आहे.</li>
    <li> वेळ व मीटर रिडींग पार्किंग ते पार्किंग असेल.</li>
    <li> ट्रीपसाठी प्रति दिवस ३०० कि.मी. अॅव्हरेज राहील / मुंबई-महावळेश्वरचे दर वेगळे राहतील.</li>
    <li> प्रवाशांच्या नावांची यादी व प्रवासाची ठिकाणे व्यवस्थित नमूद करून किमान ४ दिवस अगोदर ऑफिसमध्ये जमा करावी.</li>
    <li> बस वापरण्याचा कालावधी पहाटे ६.०० ते रात्री १२.०० पर्यंत राहील.</li>
    <li> जर रात्री १२.०० नंतर बसचा वापर झाल्यास पुढील प्रत्येक तासाला रू. ४००/- आकार पडेल.</li>
    <li> ए.सी. बस पार्किंग असतांना बसचा ए.सी. चालू केल्यास प्रत्येक तासाला रु.५००/- वेगळा चार्ज द्यावा लागेल.</li>
    <li> बस बुक करतेवेळेस ५०% अनामत व उर्वरित रक्कम बस ट्रीपला जाण्याच्या २ दिवस अगोदर भरावयाची आहे.</li>
    <li> अचानक बुकिंग कॅन्सल केल्यास संपूर्ण रकमेच्या ५०% रकमेची भरावी लागेल.</li>
    <li> वरील दिलेले दर हे सध्या चालू स्थीतीतील डिझेलच्या किंमतीनुसार आहेत.</li>
    <li> बसचा टोल FASHTAG वरून कापला जाईल त्यामुळे तुम्हाला संपूर्ण पेमेंट प्रक्रियेदरम्यान टोल शुल्काची रक्कम भरावी लागेल.</li>
    <li> आम्ही आमचे सर्वोत्तम देण्याचा प्रयत्न करतो.</li>
    <li> कोणतेही छुपे अतिरिक्त शुल्क नाही.</li>
  </ul> */}
</div>

   </div>
  );
};

export default Packages;
